/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContentZoneContext } from "cms/components/context";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import DebugJSON from "components/debug_json";
import Config from "data/config";
// import { useConvertQuillToTiptap } from "cms/rich-text/simplicity-composer-tiptap";

const RichTextTipTapComponentEditor = () => {
    
    const { expanded } = useContentZoneContext();
    // const { tiptapContent } = useConvertQuillToTiptap();
    const { component, updateFactory } = useUpdateComponent();
    const richtext = component?.richtext;
    const onChange = updateFactory("richtext");

    // prevent the editor from instantiating when the accordion is closed
    if (!expanded) {
        return null;
    }
    
    return (
        <div className='simplicity-editor-frame'>
            <SimplicityComposerTipTap
                onChange={onChange}
                richtext={richtext}
            />
            {Config.Debug.useRichTextDebug &&
                <DebugJSON name='Show' json={richtext} />
            }
        </div>
    );
};

RichTextTipTapComponentEditor.displayName = "RichTextTipTapComponentEditor";
export { RichTextTipTapComponentEditor };
